import { render, staticRenderFns } from "./UpdateCommissionLog.vue?vue&type=template&id=07f7893f&scoped=true&"
import script from "./UpdateCommissionLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateCommissionLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f7893f",
  null
  
)

export default component.exports